"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = withContext;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _imageLibrary = require("../image-library");

function withContext(Component) {
  return function ComponentWithContext(props) {
    return /*#__PURE__*/_react["default"].createElement(_imageLibrary.ImageLibraryContext.Consumer, null, function (context) {
      return /*#__PURE__*/_react["default"].createElement(Component, (0, _extends2["default"])({}, props, context));
    });
  };
}